import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterIng'
})
export class FilterIngPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(value){
      return   value.filter(
        item=>item.text.toLowerCase().indexOf(args.toLowerCase())>-1
      );      
    }
    return null;
  }

}



// WEBPACK FOOTER //
// ./src/pipes/filterIng/filterIng.pipe.ts